module.exports = __webpack_public_path__ + "img/emo_28.f6ab5553.png";